(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-herewear"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var el = document.querySelector('[data-hw-faq]');
    if (!el) return;
    var reveal = function () { el.setAttribute('data-hw-inview', ''); };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      reveal();
    } else {
      var done = false;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting && !done) { done = true; reveal(); io.disconnect(); } });
      }, { threshold: 0.05 });
      io.observe(el);
      setTimeout(function () { if (!done) { done = true; reveal(); } }, 1500);
    }
    var items = el.querySelectorAll('.hw-faq__item');
    items.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        items.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var el = document.querySelector('[data-hw-grid]');
    if (!el) return;
    var reveal = function () { el.setAttribute('data-hw-inview', ''); };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      reveal();
      return;
    }
    var done = false;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting && !done) { done = true; reveal(); io.disconnect(); } });
    }, { threshold: 0.12 });
    io.observe(el);
    setTimeout(function () { if (!done) { done = true; reveal(); } }, 1500);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-herewear"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var el = document.querySelector('[data-hw-foot]');
    if (!el) return;
    var reveal = function () { el.setAttribute('data-hw-inview', ''); };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      reveal();
      return;
    }
    var done = false;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting && !done) { done = true; reveal(); io.disconnect(); } });
    }, { threshold: 0.15 });
    io.observe(el);
    setTimeout(function () { if (!done) { done = true; reveal(); } }, 1500);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-herewear"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var hero = document.querySelector('[data-hw-hero]');
    if (!hero) return;

    requestAnimationFrame(function () {
      requestAnimationFrame(function () { hero.setAttribute('data-hw-ready', ''); });
    });

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = Math.min(window.scrollY || 0, 700);
        hero.style.setProperty('--hw-img-shift', (y * 0.06).toFixed(1) + 'px');
        hero.style.setProperty('--hw-mark-shift', (y * 0.02).toFixed(1) + 'px');
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-herewear"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var el = document.querySelector('[data-hw-news]');
    if (!el) return;
    var reveal = function () { el.setAttribute('data-hw-inview', ''); };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      reveal();
      return;
    }
    var done = false;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting && !done) { done = true; reveal(); io.disconnect(); } });
    }, { threshold: 0.2 });
    io.observe(el);
    setTimeout(function () { if (!done) { done = true; reveal(); } }, 1500);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-editorial"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var el = document.querySelector('[data-hw-page]');
    if (!el) return;
    var reveal = function () { el.setAttribute('data-hw-inview', ''); };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      reveal();
      return;
    }
    var done = false;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting && !done) { done = true; reveal(); io.disconnect(); } });
    }, { threshold: 0.05 });
    io.observe(el);
    setTimeout(function () { if (!done) { done = true; reveal(); } }, 1500);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sizing-guide"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var el = document.querySelector('[data-hw-size]');
    if (!el) return;
    var reveal = function () { el.setAttribute('data-hw-inview', ''); };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      reveal();
      return;
    }
    var done = false;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting && !done) { done = true; reveal(); io.disconnect(); } });
    }, { threshold: 0.05 });
    io.observe(el);
    setTimeout(function () { if (!done) { done = true; reveal(); } }, 1500);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trust-herewear"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var el = document.querySelector('[data-hw-trust]');
    if (!el) return;
    var reveal = function () { el.setAttribute('data-hw-inview', ''); };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      reveal();
      return;
    }
    var done = false;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting && !done) { done = true; reveal(); io.disconnect(); } });
    }, { threshold: 0.2 });
    io.observe(el);
    setTimeout(function () { if (!done) { done = true; reveal(); } }, 1500);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-herewear"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var el = document.querySelector('[data-hw-why]');
    if (!el) return;
    var reveal = function () { el.setAttribute('data-hw-inview', ''); };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      reveal();
      return;
    }
    var done = false;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !done) { done = true; reveal(); io.disconnect(); }
      });
    }, { threshold: 0.2 });
    io.observe(el);
    setTimeout(function () { if (!done) { done = true; reveal(); } }, 1500);
  })();

  } catch(e) { console.error(e); }
})();
})();
